import { IUserResource } from "@sol/sdk/users";

import { type IBriefResource } from "../../briefs";
import { EntityTypes } from "../../EntityTypes";
import { type HydraPick, type IHydraResource } from "../../types";

export enum BriefAssignmentType {
    INDIVIDUAL = "individual",
    GROUP = "group",
}

export enum BriefAssignmentState {
    ASSIGNED = "assigned",
    RENDERED = "rendered",
    CORRECTED = "corrected",
    VALIDATED = "validated",
}

export interface IBriefAssignmentItem extends IHydraResource {
    "@type": EntityTypes.BRIEF_ASSIGNMENT;
    type: BriefAssignmentType;
    brief: HydraPick<IBriefResource, "title">;
    classroom: string;
    user: IUserResource;
    state: BriefAssignmentState;
}
